import 'client-only';

import { type Brand } from '@/consts/brands';
import { post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const sendEmailVerification = (brand: Brand) =>
  post(urls[brand].api.email.sendVerification);

const autoVerifyEmail = (brand: Brand) =>
  post(urls[brand].api.email.dev.autoVerify);

export const EmailVerificationService = {
  sendEmailVerification,
  autoVerifyEmail,
};
